<h2 mat-dialog-title>Import spraw do weryfikacji klientów</h2>
<mat-dialog-content>
  <mat-stepper linear #stepper>
    <form [formGroup]="importBikVerificationForm">
      <mat-step [stepControl]="file"
                label="Plik z sprawami">
        <ng-template matStepContent>
          <mat-card class="width-100 mat-elevation-z0">
            <mat-card-content>
              Format pliku excel:
              <p>Nr. teczki z której chcesz zweryfikować klienta</p>
              <app-import-payments-select-file formControlName="file"
                                               class="width-100">
              </app-import-payments-select-file>
            </mat-card-content>
            <mat-card-actions>
              <button mat-raised-button
                      action-button
                      color="primary"
                      matStepperNext
                      [disabled]="importBikVerificationForm.invalid"
                      [action]="importBikVerification.bind(this)">
                Załaduj sprawy
              </button>
            </mat-card-actions>
          </mat-card>
        </ng-template>
      </mat-step>
    </form>
  </mat-stepper>
</mat-dialog-content>
